<div
  class="mb-1.5 flex items-center justify-between border border-gray-300 bg-gray-200 px-6 py-3 text-gray-500"
  matTooltip="Please reach out to support@panoptyc.com to restore access"
>
  <span>{{ branch().name }} <strong>[Access Suspended]</strong></span>
  @if (canManageBilling()) {
    <button (click)="manageBilling.emit($event)" class="btn manage-billing" mat-stroked-button>
      <mat-icon class="manage-billing material-icons-round">credit_card</mat-icon>
      Manage Billing
    </button>
  }
</div>
